<template>
    <div class="reporting-suggest-desktop-use">
        <img class="reporting-suggest-desktop-use__image" src="@/assets/images/page_unavailable.png" />
        <span v-html="getNotificationText"></span>
        <div class="reporting-suggest-desktop-use__button-container">
            <TotemButton
                color="primary"
                @click="$router.push({name:'home-courses'})"
                class="reporting-suggest-desktop-use__close-button"
                size="small"
                :label="$t('PageCurrentlyUnavailable_go_to_frontpage')"
            />
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            getNotificationText () {
                return this.$t('OrganizationReport.suggest_desktop_use')
            }
        }
    }
</script>

<style lang="scss" scoped>

.reporting-suggest-desktop-use {
    display: flex;
    font-family: Nunito-Regular, sans-serif;
    align-items: center;
    flex-direction: column;
    text-align: center;
    gap: 20px;

    &__image {
        margin: 0 auto;
        width: 100%;
        height: 100%;
    }

    &__close-button {
        align-self: center;
    }
}

</style>
